import { connect } from 'react-redux';
import { getSubscription } from 'src/Actions/Subscription/subscriptionAction';
import Account from './Account';

const mapStateToProps = ({ subscription,generic }) => ({
  subscription,
  generic
});

const mapDispatchToProps = (dispatch) => ({
  getSubscription: () => dispatch(getSubscription())
});

export default connect(mapStateToProps, mapDispatchToProps)(Account);